/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';

export default (set, get, key, value) => set(produce(get(), (draft) => {
  if (!draft.skuDimensions) {
    draft.skuDimensions = { };
  }
  draft.skuDimensions[key] = value;
}), false,
{ type: 'ADD_SKU_DIMENSIONS', payload: { key: value } },
);
